var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vs-component con-vs-checkbox",
      class: [
        `vs-checkbox-${_vm.color}`,
        `vs-checkbox-${_vm.size}`,
        _vm.isChecked ? `${_vm.selectedClass}` : "",
      ],
    },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "checkbox",
              staticClass: "vs-checkbox--input",
              attrs: { type: "checkbox" },
              domProps: {
                checked: _vm.isChecked || _vm.$attrs.checked,
                value: _vm.value,
              },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.listeners
        )
      ),
      _vm._v(" "),
      _c("span", { staticClass: "checkbox_x vs-checkbox", style: _vm.style }, [
        _c(
          "span",
          { staticClass: "vs-checkbox--check", style: _vm.style_check },
          [
            _c("vs-icon", {
              staticClass: "vs-checkbox--icon",
              attrs: { icon: _vm.icon, "icon-pack": _vm.iconPack },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "con-slot-label" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }